import React from 'react'
import image from '../img/vid.jpeg'
import Accordion from 'react-bootstrap/Accordion';

const Advanced = () => {
    return (
        <>
            <div className='advanced'>
                <br />
                <h1 className='text-center'>Advanced Diagnostics for Accurate Urological Care</h1>

                <div className='advanced2'>

                    <div className='advanced3'>
                        <img src={image} />
                    </div>

                    <div className='advanced3'>
                        <Accordion defaultActiveKey="0">

                            <br /> <br />
                            <Accordion.Item eventKey="0">
                                <Accordion.Header >
                                    <p style={{ fontSize: '20px' }}>Advanced Ultrasound & CT Scan</p></Accordion.Header>
                                <Accordion.Body>
                                Our state-of-the-art ultrasound and CT scan technology provide clear and detailed images of the urinary tract, kidneys, bladder, and prostate. These non-invasive tests help us identify any abnormalities, such as stones, tumours, or structural issues, with precision.
                                </Accordion.Body>
                            </Accordion.Item>

                            <br /> <br />
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <p style={{ fontSize: '20px' }}>
                                    Cystoscopy / Endoscopy

                                    </p> </Accordion.Header>
                                <Accordion.Body>
                                Cystoscopy and endoscopy are minimally invasive procedures that allow us to directly examine the bladder, urethra, and other parts of the urinary tract. This helps us diagnose conditions like infections, blockages, or tumours.
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>


                        <Accordion defaultActiveKey="0">

                            <br /> <br />
                            <Accordion.Item eventKey="0">
                                <Accordion.Header >
                                    <p style={{ fontSize: '20px' }}>Uroflowmetry & Urodynamic Study</p></Accordion.Header>
                                <Accordion.Body>
                                These tests assess the function of your bladder and urinary system. Uroflowmetry measures the flow of urine during urination, while urodynamics evaluates how well your bladder, urethra, and muscles work together. 
                                </Accordion.Body>
                            </Accordion.Item>

                            <br /> <br />
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <p style={{ fontSize: '20px' }}>
                                    Digital Rectal Examination (DRE)

                                    </p> </Accordion.Header>
                                <Accordion.Body>
                                The Digital Rectal Examination is a routine test for men to check the prostate gland. This quick, simple examination allows us to detect signs of enlargement, inflammation, or potential prostate problems.
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>



                    </div>


                </div>


            </div>

        </>
    )
}

export default Advanced
